import DestacatBasic from './DestacatBasic';
import DestacatBasicSkeleton from './DestacatBasicSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatBasicSkeleton /> : <DestacatBasic {...props} />;
}
